module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_7016.636bcf4b.png";